<template>
  <data-table :headers="tableHeaders" v-bind="$props" v-on="$listeners">
    <template #item="{ item }">
      <td>
        <v-tooltip v-if="item.automatic" bottom>
          <template #activator="{ on }">
            <v-icon color="primary" small v-on="on">language</v-icon>
          </template>
          <span>Global Rule</span>
        </v-tooltip>
        <span v-else>-</span>
      </td>
      <td><rule-icon :rule="item.type" /></td>
      <td>{{ item.meta.partner }}</td>
      <td>{{ item.meta.country }}</td>
      <td>{{ getOptionKeyByValue(offerTypes, item.offerType) }}</td>
      <td>
        <v-tooltip v-if="item.meta.offer" bottom>
          <template #activator="{ on }">
            <v-icon color="primary" small v-on="on">error</v-icon>
          </template>
          <span>{{ item.meta.offer }}</span>
        </v-tooltip>
        <template v-else>-</template>
      </td>
      <td v-if="!ignoreColumns.includes('language')">
        <v-tooltip v-if="item.meta.language" bottom>
          <template #activator="{ on }">
            <v-icon color="primary" small v-on="on">error</v-icon>
          </template>
          <span>{{ item.meta.language }}</span>
        </v-tooltip>
        <template v-else>-</template>
      </td>
      <td v-if="!ignoreColumns.includes('siteType')">
        <v-tooltip v-if="item.meta.siteType" bottom>
          <template #activator="{ on }">
            <v-icon color="primary" small v-on="on">error</v-icon>
          </template>
          <span>{{ item.meta.siteType }}</span>
        </v-tooltip>
        <template v-else>-</template>
      </td>
      <td>{{ item.priority || '-' }}</td>
      <td>{{ item.percentage || '-' }}</td>
    </template>
    <template #actions="{ item }">
      <v-list-item
        :disabled="!isPermittedTo('update')"
        :inactive="!isPermittedTo('update')"
        @click="onInteract('rule-edit', item)"
      >
        <v-list-item-title>Edit rule</v-list-item-title>
      </v-list-item>
      <v-list-item
        :disabled="!isPermittedTo('update')"
        :inactive="!isPermittedTo('update')"
        @click="onInteract('rule-delete', item)"
      >
        <v-list-item-title>Delete rule</v-list-item-title>
      </v-list-item>
      <v-divider />
      <v-list-item :to="{ name: 'partners.edit', params: { slug: item.partner } }">
        <v-list-item-title>View Partner </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="item.offer" :to="{ name: 'offers.edit', params: { slug: item.offer } }">
        <v-list-item-title>View Offer</v-list-item-title>
      </v-list-item>
    </template>
  </data-table>
</template>

<script>
import getOptionKeyByValue from '@/utils/get-option-key-by-value'
import PermissionsHandler from '@/mixins/permissions-handler'

import RuleIcon from '@/views/traffic/components/rule-icon'
import DataTable from '@/components/data-table'
import { VDataTable } from 'vuetify/lib'

export default {
  name: 'RuleTable',
  components: {
    RuleIcon,
    DataTable,
  },
  extends: VDataTable,
  mixins: [PermissionsHandler],
  props: {
    offerTypes: {
      type: Array,
      required: true,
    },
    ignoreColumns: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    tableHeaders() {
      return [
        { text: '', value: 'type' },
        { text: '', value: 'automatic' },
        { text: 'Partner', value: 'partner', width: '150' },
        { text: 'Country', value: 'geo' },
        { text: 'Offer Type', value: 'offerType' },
        { text: 'Offer', value: 'offer', width: '90' },
        { text: 'Language', value: 'language', width: '90' },
        { text: 'Site Type', value: 'siteType', width: '90' },
        { text: 'Priority', value: 'priority', width: '90' },
        { text: 'Percentage', value: 'percentage', width: '90' },
        { text: '', value: 'actions', align: 'end', width: '77' },
      ].filter(({ value }) => !this.ignoreColumns.includes(value))
    },
  },
  methods: {
    getOptionKeyByValue,
    onInteract(type, rule) {
      this.$emit(type, rule)
    },
  },
}
</script>
